import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "FuelingProcessReceiptEdit.title",
    defaultMessage: "Manual fueling process receipt",
  },
  totalAmount: {
    id: "FuelingProcessReceiptEdit.totalAmount",
    defaultMessage: "Total amount",
  },
  pricePerLiter: {
    id: "FuelingProcessReceiptEdit.pricePerLiter",
    defaultMessage: "Price per liter",
  },
  quantity: {
    id: "FuelingProcessReceiptEdit.quantity",
    defaultMessage: "Quantity",
  },
  pleaseInputTotalAmount: {
    id: "FuelingProcessReceiptEdit.pleaseInputTotalAmount",
    defaultMessage: "Please input total amount",
  },
  pleaseInputPricePerLiter: {
    id: "FuelingProcessReceiptEdit.pleaseInputPricePerLiter",
    defaultMessage: "Please input price per liter",
  },
  pleaseInputQuantity: {
    id: "FuelingProcessReceiptEdit.pleaseInputQuantity",
    defaultMessage: "Please input quantity",
  },
  save: {
    id: "FuelingProcessReceiptEdit.save",
    defaultMessage: "Save",
  },
  saving: {
    id: "FuelingProcessReceiptEdit.saving",
    defaultMessage: "Saving",
  },
  cancel: {
    id: "FuelingProcessReceiptEdit.cancel",
    defaultMessage: "Cancel",
  },
  invalidNumber: {
    id: "FuelingProcessReceiptEdit.invalidNumber",
    defaultMessage: "Please enter a valid number",
  },
  mustBePositive: {
    id: "FuelingProcessReceiptEdit.mustBePositive",
    defaultMessage: "Value must be positive",
  },
  litersLabel: {
    id: "FuelingProcessReceiptEdit.litersLabel",
    defaultMessage: "Liters",
  },
  eventualUpdateDescription: {
    id: "FuelingProcessReceiptEdit.eventualUpdateDescription",
    defaultMessage:
      "After saving please wait some time and update table to see changes.",
  },
  errorCodeRejected: {
    id: "FuelingProcessReceiptEdit.errorCodeRejected",
    defaultMessage: "Rejected",
  },
  errorCodeUnacceptableStateTransition: {
    id: "FuelingProcessReceiptEdit.unacceptableStateTransition",
    defaultMessage: "Unacceptable state transition",
  },
  errorCodeError: {
    id: "FuelingProcessReceiptEdit.errorCodeError",
    defaultMessage: "Error",
  },
  totalAmountBigDifferenceHint: {
    id: "FuelingProcessReceiptEdit.bigDifferenceHint",
    defaultMessage:
      "The total amount more than twice differs from requested amount.",
  },
  quantityBigDifferenceHint: {
    id: "FuelingProcessReceiptEdit.quantityBigDifferenceHint",
    defaultMessage:
      "The quantity more than twice differs from initial calculated quantity.",
  },
  priceBigDifferenceHint: {
    id: "FuelingProcessReceiptEdit.priceBigDifferenceHint",
    defaultMessage: "The price more than twice differs from initial price.",
  },
  saveConfirm: {
    id: "FuelingProcessReceiptEdit.saveConfirm",
    defaultMessage: "Are you sure you want to save this receipt?",
  },
});
